import {
  Component, AfterContentInit, Optional, Inject, Injector, Input, OnInit, AfterViewInit, OnDestroy, ElementRef,
  ChangeDetectionStrategy
} from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, NG_ASYNC_VALIDATORS } from '@angular/forms';

import { InputBase } from '../../../base/input-base';

@Component({
    selector: 'aa-switchable-input-text',
    templateUrl: './switchable-input-text.component.html',
    styleUrls: [
        '../input.component.scss',
        './switchable-input-text.component.scss'
    ],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: SwitchableInputTextComponent,
            multi: true,
        }],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SwitchableInputTextComponent extends InputBase<string> implements OnInit, AfterViewInit, AfterContentInit, OnDestroy
{
    private static identifier = 0;
    oldValue: string;

    public edited: boolean = false;

    @Input() onSave: (name: string, label: string, value: string) => {};

    constructor(
        @Optional() @Inject(NG_VALIDATORS) validators: Array<any>,
        @Optional() @Inject(NG_ASYNC_VALIDATORS) asyncValidators: Array<any>,
        injector: Injector
    )
    {
        super(injector);

        this.fieldId = `switchable-input-text-${SwitchableInputTextComponent.identifier++}-id`;
    }

    ngOnInit (): void
    {
    }

    ngAfterViewInit (): void
    {
    }


    ngAfterContentInit ()
    {
        this.oldValue = this.value;
    }

    ngOnDestroy ()
    {
    }

    switchMode ()
    {
        this.edited = !this.edited;
    }

    cancel ()
    {
        this.switchMode();
    }

    public save (): void
    {
        this.onSave(this.name, this.label, this.value);
        this.oldValue = this.value;
        this.switchMode();
    }
}
